/**
 * Channel registry (ENGINE-SPEC §4): every implemented channel in CHANNEL_IDS order.
 *
 * Wired by sub:channels-A with static imports of the files that existed when it finished; the
 * orchestrator finalises the list. `analyseCore(doc, ALL_CHANNELS)` runs them.
 */
import { ds01 } from './ds01.ts';
import { ds02 } from './ds02.ts';
import { ds03 } from './ds03.ts';
import { fm01 } from './fm01.ts';
import { lx01 } from './lx01.ts';
import { lx02 } from './lx02.ts';
import { lx03 } from './lx03.ts';
import { lx04 } from './lx04.ts';
import { mt01 } from './mt01.ts';
import { na01 } from './na01.ts';
import { ob01 } from './ob01.ts';
import { proc01 } from './proc01.ts';
import { proc02 } from './proc02.ts';
import { proc03 } from './proc03.ts';
import { proc04 } from './proc04.ts';
import { proc05 } from './proc05.ts';
import { proc06 } from './proc06.ts';
import { proc07 } from './proc07.ts';
import { proc08 } from './proc08.ts';
import { pt01 } from './pt01.ts';
import { pt02 } from './pt02.ts';
import { rh01 } from './rh01.ts';
import { rh02 } from './rh02.ts';
import { rh03 } from './rh03.ts';
import { sf01 } from './sf01.ts';
import { sf02 } from './sf02.ts';
import { sf03 } from './sf03.ts';
import { sf04 } from './sf04.ts';
import { sf05 } from './sf05.ts';
import { sg01 } from './sg01.ts';
import { sr01 } from './sr01.ts';
import { st01 } from './st01.ts';
import { st02 } from './st02.ts';
import { st03 } from './st03.ts';
import { st04 } from './st04.ts';
import { tr01 } from './tr01.ts';
import { tr02 } from './tr02.ts';
import { tx01 } from './tx01.ts';
import type { ChannelImpl } from './types.ts';

/** Group A (sub:channels-A): LX-01…03, PT-01, ST-01/02/04, DS-01…03, SF-04/05, PROC-03/04/05. */
export const CHANNELS_A: ChannelImpl[] = [
	lx01,
	lx02,
	lx03,
	pt01,
	st01,
	st02,
	st04,
	ds01,
	ds02,
	ds03,
	sf04,
	sf05,
	proc03,
	proc04,
	proc05,
];

/**
 * All 38 channels in CHANNEL_IDS order (TR-01 and TR-02 are the T2 translation-axis lexical channels; LX-04 is the REFIT-S
 * short-text lexical-variation channel).
 */
export const ALL_CHANNELS: ChannelImpl[] = [
	lx01,
	lx02,
	lx03,
	pt01,
	pt02,
	rh01,
	rh02,
	rh03,
	st01,
	st02,
	st03,
	st04,
	sg01,
	na01,
	fm01,
	sf04,
	ds01,
	ds02,
	ds03,
	sf05,
	mt01,
	ob01,
	sf01,
	sf02,
	sf03,
	tx01,
	sr01,
	proc01,
	proc02,
	proc03,
	proc04,
	proc05,
	proc06,
	proc07,
	proc08,
	tr01,
	tr02,
	lx04,
];
